import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Exported so LandingPage can build the FAQPage JSON-LD from the same source.
export const faqItems = [
  {
    q: 'How accurate are the sales estimates?',
    a: 'Estimates are generated from historical price, stock and review movement for each product. They are a strong directional signal for comparing products and spotting demand — always pair them with the price history chart before committing to inventory.',
  },
  {
    q: 'How is Marter different from Keepa?',
    a: 'Keepa is built for Amazon. Marter is built specifically for Walmart Marketplace: Walmart price history, Walmart seller data, and a Chrome extension that works directly on Walmart product pages. See our full comparison at getmarter.com/compare.',
    link: { href: '/compare', label: 'full comparison' },
  },
  {
    q: 'Do you offer a free trial?',
    a: 'Yes — every new account starts with a 7-day free trial with full access to all features. You are not charged until the trial ends, and you can cancel during the trial.',
  },
  {
    q: 'What happens after the trial?',
    a: 'Your subscription starts at $24 per month (or $240 per year — two months free). One plan, everything included. No surprise upgrades.',
  },
  {
    q: 'Who is Marter for?',
    a: 'Walmart Marketplace sellers doing online arbitrage, retail arbitrage or wholesale — anyone who needs product data before deciding what to buy and sell.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes. Cancel or manage your subscription anytime from the manage-subscription page — no cancellation fees.',
    link: { href: '/manage-subscription', label: 'manage-subscription page' },
  },
  {
    q: 'How do I contact support?',
    a: 'Email us at info@getmarter.com — we respond promptly, before and after you subscribe.',
  },
];

export default function FAQ() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container
      id="faq"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Typography
        component="h2"
        variant="h4"
        color="text.primary"
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: 'center',
        }}
      >
        Frequently asked questions
      </Typography>
      <Box sx={{ width: '100%', maxWidth: '860px' }}>
        {faqItems.map((item, index) => {
          const panel = `panel${index}`;
          return (
            <Accordion
              key={panel}
              expanded={expanded === panel}
              onChange={handleChange(panel)}
              sx={{
                '&:before': { display: 'none' },
                boxShadow: 'none',
                border: '1px solid rgba(26,26,26,0.08)',
                borderRadius: '10px !important',
                mb: 1,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${panel}-content`}
                id={`${panel}-header`}
              >
                <Typography component="h3" variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {item.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ maxWidth: { sm: '100%', md: '85%' }, textAlign: 'left' }}
                >
                  {item.link ? (
                    <>
                      {item.a.split(item.link.label)[0]}
                      <Link href={item.link.href}>{item.link.label}</Link>
                      {item.a.split(item.link.label)[1]}
                    </>
                  ) : (
                    item.a
                  )}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Container>
  );
}
